"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentFilter = exports.CustomDropdownFilter = exports.ActivityFilterImplementation = exports.DefaultActivityFilterOptionsArgs = exports.StudentFilterImplementationArgs = exports.StudentFilterArgs = exports.MultiDropdownArgs = exports.BasicDropdownArgs = void 0;
var react_1 = __importStar(require("react"));
var Avatar_1 = __importDefault(require("@mui/material/Avatar"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
var Chip_1 = __importDefault(require("@mui/material/Chip"));
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var colors_1 = require("@mui/material/colors");
var il_default_avatar_1 = require("../il-student-card/il-default-avatar");
var enums_1 = require("../../shared/enums");
var icons_1 = require("../../shared/icons");
var il_dropdown_1 = require("./il-dropdown");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
var constants_1 = require("../../shared/constants");
var user_config_1 = require("../../configs/user.config");
var icon_1 = require("../icon/icon");
// default args
exports.BasicDropdownArgs = {
    items: [
        {
            value: 'firstUsername',
            option: 'FirstName LastName',
        },
        {
            value: 'secondUsername',
            option: react_1.default.createElement("span", null, "SecondName LastName"),
        },
        {
            value: 'thirdUsername',
            option: react_1.default.createElement("span", null, "ThirdName LastName"),
        },
    ],
    defaultValue: ['secondUsername'],
    variant: enums_1.DropdownVariantEnum.OUTLINED,
};
// default args
exports.MultiDropdownArgs = {
    items: [
        {
            value: 'Toggle All',
            option: 'Toggle All',
        },
        {
            value: 'firstUsername',
            option: 'FirstName LastName',
        },
        {
            value: 'secondUsername',
            option: react_1.default.createElement("span", null, "SecondName LastName"),
        },
        {
            value: 'thirdUsername',
            option: react_1.default.createElement("span", null, "ThirdName LastName"),
        },
        {
            value: 'fourthUsername',
            option: 'FourthName LastName',
        },
    ],
    multiple: true,
    defaultValue: ['fourthUsername'],
    selectAllValue: 'Toggle All',
    variant: enums_1.DropdownVariantEnum.OUTLINED,
};
exports.StudentFilterArgs = {
    items: [
        {
            value: 'All Students',
            option: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(icons_1.AllStudentsSvgIcon, { height: "15", width: "15", style: { marginRight: '16px' } }),
                react_1.default.createElement(Typography_1.default, { gutterBottom: true, variant: "h5", component: "span" }, "All Students"))),
        },
        {
            value: 'Joey',
            option: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Avatar_1.default, { sx: {
                        width: 15,
                        height: 15,
                        fontSize: 10,
                        bgcolor: colors_1.deepOrange[500],
                        mr: 2,
                    } }, "JD"),
                react_1.default.createElement(Typography_1.default, { gutterBottom: true, variant: "h5", component: "span" }, "Joey"))),
        },
        {
            value: 'deedee',
            option: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Avatar_1.default, { sx: {
                        width: 15,
                        height: 15,
                        fontSize: 10,
                        bgcolor: colors_1.deepPurple[500],
                        mr: 2,
                    } }, "DD"),
                react_1.default.createElement(Typography_1.default, { gutterBottom: true, variant: "h5", component: "span" }, "Dee Dee"))),
        },
        {
            value: 'gary',
            option: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Avatar_1.default, { sx: {
                        width: 15,
                        height: 15,
                        fontSize: 10,
                        bgcolor: colors_1.green[500],
                        mr: 2,
                    } }, "GD"),
                react_1.default.createElement(Typography_1.default, { gutterBottom: true, variant: "h5", component: "span" }, "Gary"))),
        },
    ],
    renderValue: function (selected) { return (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', flexWrap: 'wrap', gap: 0.5 } }, Array.isArray(selected)
        ? selected.map(function (value) { return (react_1.default.createElement(Chip_1.default, { avatar: react_1.default.createElement(Avatar_1.default, null, value.slice(0, 3)), key: value, label: value })); })
        : typeof selected === 'string' && (react_1.default.createElement(Chip_1.default, { avatar: react_1.default.createElement(Avatar_1.default, null, selected.slice(0, 3)), key: selected, label: selected })))); },
    defaultValue: ['Joey'],
    variant: enums_1.DropdownVariantEnum.OUTLINED,
};
exports.StudentFilterImplementationArgs = [
    {
        guid: '81d571e9-8f5b-45e1-a315-41ee6f5d9c55',
        username: 'gareth.teach1',
        firstName: 'Gareth',
        lastName: 'Garcia',
        email: 'gareth.Garcia@gmail.com',
        schoolGuid: 'e2b87a0a-fa27-40b6-9a13-5d3d1eaaf089',
        role: enums_1.IdentityRolesEnum.TEACHER,
        brand: enums_1.BrandEnum.MONARCH,
        avatar: 'RED',
        lastLoginDate: '2022-02-28T18:35:24Z',
        active: true,
    },
    {
        guid: '82553bb2-e9d3-40d6-b85b-7ad69de863e3',
        username: 'monarch.student1',
        firstName: 'Diego',
        lastName: 'Garcia',
        email: 'Diego.Garcia@gmail.com',
        schoolGuid: 'e2b87a0a-fa27-40b6-9a13-5d3d1eaaf089',
        role: enums_1.IdentityRolesEnum.STUDENT,
        brand: enums_1.BrandEnum.MONARCH,
        avatar: 'RED',
        lastLoginDate: '2022-02-28T18:35:24Z',
        active: true,
    },
    {
        guid: 'a5cb75cc-a83b-4f74-9e96-d157e95e3115',
        username: 'monarch.student2',
        firstName: 'Juan',
        lastName: 'Garcia',
        email: 'Juan.Garcia@gmail.com',
        schoolGuid: 'e2b87a0a-fa27-40b6-9a13-5d3d1eaaf089',
        role: enums_1.IdentityRolesEnum.STUDENT,
        brand: enums_1.BrandEnum.MONARCH,
        avatar: 'BLUE',
        lastLoginDate: '2022-02-28T18:35:24Z',
        active: true,
    },
];
var RenderOption = function (_a) {
    var allStudentUserGuid = _a.allStudentUserGuid, avatar = _a.avatar, firstName = _a.firstName, guid = _a.guid, selectedValue = _a.selectedValue;
    return (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', flexWrap: 'wrap' } },
        react_1.default.createElement(Box_1.default, { sx: { mr: 2 } }, guid === allStudentUserGuid ? (react_1.default.createElement(icons_1.AllStudentsSvgIcon, { height: "25", width: "25", sx: { color: selectedValue === guid ? 'primary.main' : '' } })) : (react_1.default.createElement(il_default_avatar_1.ILDefaultAvatar, { color: (avatar && user_config_1.userConfig.color[avatar]) || avatar,
            width: 25,
            height: 25 }))),
        react_1.default.createElement(Typography_1.default, { variant: "h5", component: "span", sx: { mb: 0, mt: '5px', color: selectedValue === guid ? 'primary.main' : '' } }, firstName)));
};
var selectOption = function (_a) {
    var avatar = _a.avatar, firstName = _a.firstName, guid = _a.guid, allStudentUserGuid = _a.allStudentUserGuid, selectedValue = _a.selectedValue;
    return {
        value: guid || '',
        option: RenderOption({
            allStudentUserGuid: allStudentUserGuid,
            avatar: avatar,
            firstName: firstName || '',
            guid: guid || '',
            selectedValue: selectedValue,
        }),
    };
};
function StudentFilter(_a) {
    var clearAll = _a.clearAll, _b = _a.multiple, multiple = _b === void 0 ? false : _b, onChange = _a.onChange, sx = _a.sx, studentsArr = _a.studentsArr, props = __rest(_a, ["clearAll", "multiple", "onChange", "sx", "studentsArr"]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var _c = (0, react_1.useState)([constants_1.allStudentUser.guid]), defaultVal = _c[0], setDefaultVal = _c[1];
    var _d = (0, react_1.useState)(constants_1.allStudentUser.guid), selectedValue = _d[0], setSelectedValue = _d[1];
    var findUserByValue = function (value) { return studentsArr === null || studentsArr === void 0 ? void 0 : studentsArr.find(function (user) { return user.guid === value[0]; }); };
    var _e = (0, react_1.useState)([
        selectOption(__assign(__assign({}, constants_1.allStudentUser), { allStudentUserGuid: constants_1.allStudentUser.guid, selectedValue: selectedValue })),
    ]), items = _e[0], setItems = _e[1];
    var onChangeHandler = function (selected) {
        setSelectedValue(Array.isArray(selected) ? selected[0] : selected);
        onChange && onChange(selected);
    };
    (0, react_1.useEffect)(function () {
        function fetchItems() {
            var studentsArrCopy = __spreadArray([], studentsArr, true);
            var studentItems = [];
            if ((studentsArrCopy === null || studentsArrCopy === void 0 ? void 0 : studentsArrCopy.findIndex(function (student) { return student.guid === constants_1.allStudentUser.guid; })) === -1) {
                studentsArrCopy.unshift(constants_1.allStudentUser);
            }
            studentsArrCopy === null || studentsArrCopy === void 0 ? void 0 : studentsArrCopy.forEach(function (student) {
                return studentItems.push(selectOption(__assign(__assign({}, student), { allStudentUserGuid: constants_1.allStudentUser.guid, selectedValue: selectedValue })));
            });
            setItems(studentItems);
            setDefaultVal(
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            studentsArrCopy && studentsArrCopy.length === 2
                ? [studentsArrCopy[1].guid]
                : [constants_1.allStudentUser.guid]);
        }
        fetchItems();
    }, [studentsArr, selectedValue]);
    return (react_1.default.createElement(CustomDropdownFilter, __assign({ defaultValue: defaultVal,
        multiple: multiple, items: items, clearAll: clearAll, onChange: onChangeHandler, sx: sx, renderValue: function (selected) {
            var _a;
            var _b = (_a = findUserByValue(Array.isArray(selected) ? selected : [selected])) !== null && _a !== void 0 ? _a : constants_1.allStudentUser, avatar = _b.avatar, firstName = _b.firstName, guid = _b.guid;
            return RenderOption({
                avatar: avatar,
                firstName: firstName,
                guid: guid,
                allStudentUserGuid: constants_1.allStudentUser.guid,
                selectedValue: guid,
            });
        } }, props)));
}
exports.default = StudentFilter;
exports.StudentFilter = StudentFilter;
var defaultIconSx = { '& svg': { height: '0.9375rem', width: '0.9375rem' } };
exports.DefaultActivityFilterOptionsArgs = [
    {
        activity: 'Overdue',
        count: 9,
        icon: react_1.default.createElement(icon_1.Icon, { icon: enums_1.IconEnum.CLOCK, sx: defaultIconSx }),
    },
    {
        activity: 'Lessons',
        count: 8,
        icon: react_1.default.createElement(icon_1.Icon, { icon: enums_1.IconEnum.BOOK, sx: defaultIconSx }),
    },
    {
        activity: 'Projects',
        count: 7,
        icon: react_1.default.createElement(icon_1.Icon, { icon: enums_1.IconEnum.NOTEBOOK, sx: defaultIconSx }),
    },
    {
        activity: 'Quizzes',
        count: 8,
        icon: react_1.default.createElement(icon_1.Icon, { icon: enums_1.IconEnum.CIRCLE_QUESTION, sx: defaultIconSx }),
    },
    {
        activity: 'Tests',
        count: 4,
        icon: react_1.default.createElement(icon_1.Icon, { icon: enums_1.IconEnum.STAR, sx: defaultIconSx }),
    },
    {
        activity: 'Events',
        count: 10,
        icon: react_1.default.createElement(icon_1.Icon, { icon: enums_1.IconEnum.CALENDAR_STAR, sx: defaultIconSx }),
    },
    {
        activity: 'Resources',
        count: 1,
        icon: react_1.default.createElement(icon_1.Icon, { icon: enums_1.IconEnum.LIGHT_BOOKS, sx: defaultIconSx }),
    },
];
function CustomDropdownFilter(_a) {
    var items = _a.items, clearAll = _a.clearAll, defaultValue = _a.defaultValue, onChange = _a.onChange, sx = _a.sx, _b = _a.renderValue, renderValue = _b === void 0 ? function (selected) { return (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', flexWrap: 'wrap', gap: 0.5 } }, selected === null || selected === void 0 ? void 0 : selected.map(function (value) { return (react_1.default.createElement(Chip_1.default, { avatar: react_1.default.createElement(Avatar_1.default, null, value.slice(0, 2)), key: value, label: value })); }))); } : _b, props = __rest(_a, ["items", "clearAll", "defaultValue", "onChange", "sx", "renderValue"]);
    return (react_1.default.createElement(il_dropdown_1.ILDropdown, __assign({ items: items, onChange: onChange, defaultValue: defaultValue, renderValue: renderValue, clearAll: clearAll, sx: __assign({ m: 1, minWidth: 300, pr: 1 }, sx),
        variant: enums_1.DropdownVariantEnum.OUTLINED,
        IconComponent: function (props) { return (react_1.default.createElement(il_icon_common_1.SolidIcon, __assign({ icon: props.className.includes('Open')
                ? solid_icon_definitions_1.SolidIconDefinitions.CHEVRON_UP
                : solid_icon_definitions_1.SolidIconDefinitions.CHEVRON_DOWN }, props))); } }, props)));
}
exports.CustomDropdownFilter = CustomDropdownFilter;
function ActivityFilterImplementation(_a) {
    var _b = _a.activities, activities = _b === void 0 ? exports.DefaultActivityFilterOptionsArgs : _b, onChange = _a.onChange, _c = _a.textSize, textSize = _c === void 0 ? 15 : _c, props = __rest(_a, ["activities", "onChange", "textSize"]);
    var _d = (0, react_1.useState)(activities.map(function (a) { return a.activity; })), selectedChecks = _d[0], setSelectedChecks = _d[1];
    var items = activities.map(function (_a) {
        var activity = _a.activity, count = _a.count, icon = _a.icon;
        return {
            value: activity,
            option: (react_1.default.createElement(Grid_1.default, { container: true, direction: "row", spacing: 2, alignItems: "center", justifyContent: "center" },
                react_1.default.createElement(Grid_1.default, { item: true, xs: 2 },
                    react_1.default.createElement(Checkbox_1.default, { edge: "start", checked: selectedChecks.indexOf(activity) !== -1 })),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 2 }, icon),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 6 }, activity),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 2 }, count))),
        };
    });
    items.push({
        value: 'clear All',
        option: (react_1.default.createElement(Grid_1.default, { container: true, direction: "row", spacing: 2, alignItems: "center", justifyContent: "center" },
            react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(Button_1.default, null, "Clear All")))),
    });
    var onChangeOption = function (selectedValues) {
        setSelectedChecks(selectedValues);
        onChange && onChange(selectedValues);
    };
    return (react_1.default.createElement(CustomDropdownFilter, __assign({ items: items, clearAll: 'clear All',
        value: selectedChecks,
        onChange: onChangeOption,
        multiple: true,
        onClose: function () {
            selectedChecks.length === 0 && onChangeOption(activities.map(function (a) { return a.activity; }));
        },
        renderValue: function (selected) {
            var text = selected === null || selected === void 0 ? void 0 : selected.join(', ');
            if (text.length > textSize) {
                text = text.substring(0, textSize) + '...';
            }
            return (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', flexWrap: 'wrap', gap: 0.5 } },
                activities.length === selected.length && react_1.default.createElement(Typography_1.default, null, "All Activities"),
                selected.length > 0 && activities.length !== selected.length && (react_1.default.createElement(Typography_1.default, null, text))));
        } }, props)));
}
exports.ActivityFilterImplementation = ActivityFilterImplementation;
